export enum PAGE_CONTAINER_TYPE {
  FRAME_PAGE = 'inlineFrameTab',
  STATUS_PAGE = 'statusPage',
  TABLEAU_PAGE = 'tableauPage',
  BUCKET_BROWSER_PAGE = 'bucketBrowserPage',
  EXTERNAL_URL_PAGE = 'externalUrl',
  FORM_PAGE = 'formPage'
}